/**
 * @desc 导出现有货架
 */
const URL = "/rantion-wms";
import http, { updateResponse } from "@/http";
export function request(options?: any) {
  return updateResponse(
    http(URL + `/storageUnit/export`, {
      method: "GET",

      ...options,
    }),
  );
}
